import axios from 'axios';
import { getUserToken } from '../utils/helper';
import config from '../config';

export const CREATE_BATCH = 'CREATE_BATCH';
export const CREATE_BATCH_SUCCESS = 'CREATE_BATCH_SUCCESS';
export const CREATE_BATCH_FAIL = 'CREATE_BATCH_FAIL';
export const CREATE_BATCH_RESET = 'CREATE_BATCH_RESET';

export const createBatch = (params) => ({
  type: CREATE_BATCH,
  params,
});

export const createBatchSuccess = (response) => ({
  type: CREATE_BATCH_SUCCESS,
  response,
});

export const createBatchFail = (response) => ({
  type: CREATE_BATCH_FAIL,
  response,
});

export const createBatchReset = () => ({
  type: CREATE_BATCH_RESET,
});

export const createBatchApi = (data) => {
  return (dispatch) => {
    dispatch(createBatch());
    return axios.post(`${config.api.base_url}/batch/create`, data, {
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: 'Bearer ' + getUserToken(),
      },
    })
    .then((response) => {
      dispatch(createBatchSuccess(response.data));
      return response.data;
    })
    .catch((error) => {
      const errorMsg = error.response?.data || error.message;
      dispatch(createBatchFail(errorMsg));
      throw error;
    });
  };
}; 